var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c(_setup.HotelPaymentModal,{attrs:{"is-opened":_setup.isHotelOpened},on:{"confirm":_setup.onConfirmHotel,"back":_setup.onClickBack}}),_c(_setup.ConfirmedHotelPaymentModal,{attrs:{"is-opened":_setup.isConfirmedOpened,"is-loading":_setup.isLoading},on:{"ok":_setup.next}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }